import * as perfectScrollbar from './perfect-scrollbar/perfect-scrollbar';
import * as slickCarousel from './slick-carousel/slick-carousel';
import * as reactDayPicker from './react-day-picker/react-day-picker';

export default {
  perfectScrollbar,
  slickCarousel,
  reactDayPicker
};
